export const onlyNumber = (input, toInt = false) => {
  // Handle null/undefined
  if (input === null || input === undefined) {
    return toInt ? 0 : '';
  }

  // Convert to string first
  const str = String(input);

  // Extract numbers
  const numbersOnly = str.replace(/[^0-9]/g, '');

  // Handle empty result
  if (!numbersOnly) {
    return toInt ? 0 : '';
  }

  // Return appropriate type
  return toInt ? Number(numbersOnly) : numbersOnly;
};

export const formatCurrency = (number, withPrefix = null) => {
  if (number) {
    let formattedNumber = number.toString().replace(/\D/g, '');

    // Remove leading zeros
    formattedNumber = formattedNumber.replace(/^0+/, '');

    // If the string is empty after removing zeros (was all zeros), return "0"
    if (formattedNumber === '') {
      formattedNumber = '0';
    }

    let rest = formattedNumber.length % 3;
    let currency = formattedNumber.substr(0, rest);
    let thousand = formattedNumber.substr(rest).match(/\d{3}/g);
    let separator;

    if (thousand) {
      separator = rest ? ',' : '';
      currency += separator + thousand.join(',');
    }

    if (withPrefix) {
      currency = `${withPrefix} ${currency}`;
    }

    return currency;
  } else {
    return '';
  }
};
